import { BroadcastMessage } from '@aipb/gulliver/env/model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CookieService } from 'ngx-cookie-service';
import { BroadcastMessageService } from './broadcast-message.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fr-broadcast-message',
  templateUrl: './broadcast-message.component.html',
  styleUrls: ['./broadcast-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CookieService, BroadcastMessageService],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  animations: [
    trigger('slideOut', [
      transition(':leave', [
        style({
          height: '*',
          opacity: 1
        }),
        animate(
          300,
          style({
            height: 0,
            opacity: 0
          })
        )
      ])
    ])
  ]
})
export class BroadcastMessageComponent implements OnInit {
  @Input() broadcastMessage: BroadcastMessage;

  public active$ = this.service.active$;

  constructor(private service: BroadcastMessageService) {}

  ngOnInit(): void {
    this.service.init(this.broadcastMessage);
  }

  onClose() {
    this.service.close();
  }
}
